import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BanqueService from "../../services/Banque";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Snackbar, TextField } from "@material-ui/core";
import DataTablePayamentsForBordereau from "./DataTablePayamentsForBordereau";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../components/layouts/WithLoader";

const PayementsByBankAccount = ({startLoading,stopLoading}) => {
  const [banqueAccountInfo, setBanqueAccountInfo] = useState();
  const [listTransaction, setListTransaction] = useState([]);
  const [dateBegin, setDateBegin] = useState("any");
  const [methodePayement, setMethodePayement] = useState();

  const [dateEnd, setDateEnd] = useState("any");
  const navigate = useNavigate();
  useEffect(() => {
    BanqueService.getBankAccountInfo(sessionStorage.getItem("idBankAccount"))
      .then((response) => {
        console.log(response);
        if (response.data.success) {
          setBanqueAccountInfo(response.data.success);
        }
      })
      .catch(() => {
        console.log("error");
      });
  }, []);

  const onGetChequeByFiltersHandler = () => {
    startLoading()
    BanqueService.getListPayementsChequeByBankAccountBetweenDates(
      getCurrentUserId(),
      sessionStorage.getItem("idBankAccount"),
      methodePayement,
      dateBegin,
      dateEnd
    )
      .then((response) => {
        console.log(response);
        if (response.data.success) {
          setListTransaction(response.data.success);
        }
      })
      .catch(() => {
        console.log("error");
      }).finally(() => {
        stopLoading()
      })
  };

  const handleChangePayementMethode = (event) => {
    if (event.target.value === "VIREMENT") {
      setMethodePayement(3);
    } else if (event.target.value === "CHEQUE") {
      setMethodePayement(2);
    }
  };

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value.concat(":00"));
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value.concat(":00"));
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h4 class="card-title">Le Compte </h4>
                  <br />
                  <br />
                  {banqueAccountInfo && (
                    <>
                      <p> RIB :{banqueAccountInfo.rib}</p>
                      <p>Compte :{banqueAccountInfo.name}</p>
                      <p>Adresse :{banqueAccountInfo.agenceLocalisation}</p>
                    </>
                  )}
                </div>
              </div>

              {/* {listTransaction && <DataTableTransactions listTransaction={listTransaction} />} */}
            </div>
          </div>
        </div>
      </div>

      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputClientCompany">
                          Choisir le Payement
                        </label>
                        <select
                          class="form-control"
                          onChange={handleChangePayementMethode}
                        >
                          <option key={0} value={0}>
                            Sélectionner un mode de payement
                          </option>

                          <option key={1} value={"CHEQUE"}>
                            Chèques / Traites
                          </option>
                          <option key={2} value={"VIREMENT"}>
                            Virement
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="datetime-local"
                          // label="Date Début"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          // label="Date fin"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetChequeByFiltersHandler}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              {listTransaction.length > 0 && (
               
                  <DataTablePayamentsForBordereau
                    listTransaction={listTransaction}
                  />
               
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(PayementsByBankAccount);
